<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('button.search') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('notification.list.Notification Title') }}</label>
                        <InputText id="nameuser" :class="`${error.name ? 'p-invalid' : ''}`" type="text" placeholder="알림 제목으로 찾기" v-model="notification_title" />
                        <div class="text-red">{{ error.name }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('notification.list.Notification Type') }}</label>
                        <Dropdown id="state" v-model="notification_type" :options="genders" optionLabel="name" placeholder="Select"></Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('notification.list.Start Date') }}</label>
                        <Calendar :class="`${error.calendarValue ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="start_date" dateFormat="yy.mm.dd" placeholder="YYYY-MM-DD"></Calendar>
                        <div class="text-red">{{ error.calendarValue }}</div>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('notification.list.End Date') }}</label>
                        <Calendar :class="`${error.calendarValue ? 'p-invalid' : ''}`" :showIcon="true" :showButtonBar="true" v-model="end_date" dateFormat="yy.mm.dd" placeholder="YYYY-MM-DD"></Calendar>
                        <div class="text-red">{{ error.calendarValue }}</div>
                    </div>
                </div>

                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button>
                        <!-- <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button> -->
                    </div>
                    <div>
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-button-sm p-mr-2 p-mb-2" @click="searchuser"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="resetUser"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div>
                        <h5>알림목록</h5>
                    </div>
                    <div>
                        <router-link :to="'/addnotification'">
                            <Button label="Primary" class="p-mr-2 p-mb-2" @click="addNew"><i class="pi pi-plus p-mr-2"></i>{{ $t('notification.list.Add New') }}</Button>
                        </router-link>
                        <!-- <Button label="Primary" class="p-mr-2 p-mb-2" @click="openBasic()"><i class="pi pi-download p-mr-2"></i>{{ $t('button.downloadExcel') }}</Button> -->
                    </div>
                    <Dialog header="Please enter reason for download this file" v-model:visible="displayBasic" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '25vw' }">
                        <h5 style="margin-top: 10px">Enter Reason</h5>
                        <Textarea v-model="downloadReason" rows="10" style="width: 100%" maxlength="200" @input="Whenchange" />
                        <small style="color: gray">200 character maximum.</small>
                        <template #footer>
                            <Button label="Submit" icon="pi pi-check" @click="exceldownload" :disabled="IsDisable" />
                            <Button label="Cancel" icon="pi pi-times" @click="closeBasic" autofocus />
                        </template>
                    </Dialog>
                </div>
                <DataTable :value="customer1" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty> No Data found. </template>
                    <template #loading> Loading data. Please wait. </template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('#')">
                        <template #body="{ index }">
                            <span class="p-column-title">Name</span>
                            {{ index + 1 }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('notification.list.Notification Title')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Notification Title</span>
                            {{ data.notification_title }}
                        </template>
                    </Column>
                    <Column :header="$t('notification.list.Notification Type')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Notification Type</span>
                            {{ data.notification_type }}
                        </template>
                    </Column>
                    <Column :header="$t('notification.list.Description')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Description</span>
                            {{ data.description == '' ? '- Empty -' : data.description }}
                        </template>
                    </Column>
                    <Column :header="$t('notification.list.Posted Date')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Mobile</span>
                            {{ formatDate(data.posted_date) }}
                        </template>
                    </Column>
                    <Column :header="$t('notification.list.Action')">
                        <template #body="{ data }">
                            <span class="p-column-title">Balance</span>
                            <!-- <p style="display: none">{{ data.mobile }}</p> -->
                            <div style="display: flex">
                                <router-link :to="'/viewnotification/' + data.notification_code"
                                    ><Button label="info" class="p-button2" @mouseenter="getParams(data.notification_type)"><i class="pi pi-eye p-mr-2"></i> </Button>
                                </router-link>
                                <!-- <span v-if="data.notification_type == 'manual'">
                                    <router-link :to="'/viewnotification/' + data.notification_code"
                                        ><Button label="info" class="p-button2" @mouseenter="getParams(data.notification_type)"><i class="pi pi-eye p-mr-2"></i> </Button>
                                    </router-link>
                                </span> -->
                                <!-- <span v-else-if="data.notification_type == 'coupon'">
                                    <router-link :to="'/viewnotification/' + data.notification_code"
                                        ><Button label="info" class="p-button2" @mouseenter="getParams(data.notification_type)"><i class="pi pi-eye p-mr-2"></i> </Button>
                                    </router-link>
                                </span> -->
                                <!-- <span v-else>
                                    <router-link :to="'/viewnotification/' + data.notification_code"
                                        ><Button label="info" class="p-button2" @mouseenter="getParams(data.notification_type)"><i class="pi pi-eye p-mr-2"></i> </Button>
                                    </router-link>
                                </span> -->

                                <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.notification_code)" />
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
// import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import NotificationService from '../../service/API/NotificationService';
import axios from 'axios';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    data() {
        return {
            downloadReason: '',
            IsDisable: true,
            displayBasic: false,
            selected: [],
            selectedItemss: '',
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,

            customer1: null,
            loading1: true,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            genders: [
                { name: 'Statistical', code: 'statistical' },
                { name: 'Coupon', code: 'coupon' },
                { name: 'Survey reminder', code: 'survey' },
                { name: 'Manual', code: 'manual' },
            ],
            pets: [
                { name: 'Yes', code: 'Yes' },
                { name: 'No', code: 'No' },
            ],
            marital_statuss: [
                { name: 'married', code: 'married' },
                { name: 'unmarried', code: 'unmarried' },
            ],
            age_groups: [
                { name: '25~35', code: '25 ~ 35' },
                { name: '35~45', code: '35 ~ 45' },
                { name: '45~55', code: '45 ~ 55' },
                { name: '55~65', code: '55 ~ 65' },
            ],
            dropdownItem: null,
            error: {},
            //params for list
            Ntitle: '',
            notification_title: '',
            start_date: '',
            end_date: '',
            id: '',
            del_id: '',
            notification_type: '',
            searchstartdate: '',
            notification_code: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.notificationService = new NotificationService();
    },
    mounted() {
        this.getlist();
    },
    watch: {},
    methods: {
        Whenchange() {
            if (this.downloadReason != '') {
                this.IsDisable = false;
            } else {
                this.IsDisable = true;
            }
        },
        openBasic() {
            this.displayBasic = true;
        },
        closeBasic() {
            this.displayBasic = false;
        },
        getlist() {
            this.notificationService.getNotificationList(this.notification_title, this.notification_type?.code, this.searchstartdate, this.end_date).then((data) => {
                let list = data.map((item, index) => ({ ...item, slNo: index + 1 }));
                this.customer1 = list;
                this.loading1 = false;
                this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
            });
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '.' + mm + '.' + dd);
        },
        resetUser() {
            this.notification_title = '';
            this.notification_type = '';
            this.start_date = '';
            this.end_date = '';
            this.getlist();
        },
        searchuser() {
            if (this.notification_title == '' && this.notification_type == '' && this.start_date == '' && this.end_date == '') {
                this.$toast.add({ severity: 'error', summary: 'Error message', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                if (this.start_date != '') {
                    this.searchstartdate = this.addDay(this.start_date);
                } else {
                    this.searchstartdate = '';
                }
                this.getlist();
            }
        },
        exceldownload() {
            this.notificationService.getExcel(this.notification_title, this.notification_type == '' ? '' : this.notification_type.code, this.start_date, this.end_date,this.downloadReason).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Notificationlist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
                this.closeBasic();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            let dd = date.getDate();
            let mm = date.getMonth() + 1;
            let yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '-' + mm + '-' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },

        confirm(notification_code) {
            let self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'post', url: `/notification/remove `, data: { notification_code: notification_code } }).then(function (response) {
                        console.log(response);
                        self.notificationService.getNotificationList(self.notification_title, self.notification_type?.code, self.searchstartdate, self.end_date).then((data) => {
                            console.log(data);
                            self.customer1 = data;
                            self.loading1 = false;
                            self.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                        }) .catch((err) => {
                            if (err.response.data.statusCode == '401') {
                                localStorage.removeItem('token');
                                window.location.href = '/login';
                            }
                        });
                    });

                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                    // self.notificationService
                    //     .getNotificationList(self.notification_title,self.notification_type?.code,self.searchstartdate,self.end_date)
                    //     .then((data) => {
                    //         console.log(data);
                    //         this.customer1 = data;
                    //         this.loading1 = false;
                    //         this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                    //     });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}
.p-fluid {
    .p-button {
        width: auto;
    }
}
</style>
